<template>
	<div class="avatars-group display-flex flex-row flex-align-center" v-if="displayItems">
		<div class="avatar" :key="item.id" v-for="(item, i) in displayItems" :style="{ 'z-index': displayItems.length + i }">
			<AppTooltip :position="tooltipDirection" :text="item.name">
				<AppGroupAvatar v-if="item.isGroup" :group="item" :size="26" />
				<SettingsManageUsersInfoAvatar v-if="item.isUser" initials showBorder :user="item" :size="26" />
			</AppTooltip>
		</div>
		<div v-if="othersCount > 0" class="count-others ml-1">+{{ othersCount }}</div>
	</div>
</template>

<script>
import { groups } from '@/store/modules/accountGroups/getters';
import { getGroups } from '@/store/modules/accountGroups/actions';
import { getAccountMembers } from '@/store/modules/account/actions';
import { teamMemberByUserId } from '@/store/modules/account/getters';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import SettingsManageUsersInfoAvatar from '@/components/SettingsManageUsersInfoAvatar.vue';
export default {
	name: 'AppAvatarGroup',
	components: { SettingsManageUsersInfoAvatar },
	props: {
		numToShow: { type: Number, default: 5 },
		userIds: { type: Array, default: () => [] },
		groupIds: { type: Array, default: () => [] },
		tooltipDirection: { type: String, default: 'top' },
	},
	computed: {
		...mapGettersShorthand({ teamMemberByUserId, groups }),
		fullUsers() {
			return this.userIds.map((userId) => ({ ...this.teamMemberByUserId(userId), isUser: true }));
		},
		displayUsers() {
			return this.fullUsers?.slice(0, this.numToShow);
		},
		displayGroups() {
			if (this.displayUsers.length >= this.numToShow) {
				return [];
			}
			const numGroupsToShow = this.numToShow - this.displayUsers.length;
			return this.fullGroups?.slice(0, numGroupsToShow);
		},
		displayItems() {
			return [...this.displayUsers, ...this.displayGroups];
		},
		fullGroups() {
			return this.groups?.filter((group) => this.groupIds?.includes(group.id)).map((x) => ({ ...x, isGroup: true }));
		},
		othersCount() {
			const all = this.fullUsers.length + this.fullGroups.length;
			if (all > this.numToShow) {
				return all - this.numToShow;
			}
			return 0;
		},
	},
	methods: { ...mapActionsShorthand({ getAccountMembers, getGroups }) },
	async mounted() {
		await this.getAccountMembers();
		await this.getGroups();
	},
};
</script>
<style scoped lang="scss">
.avatars-group {
	.avatar {
		&:not(:first-child) {
			margin-left: -8px !important;
		}
	}
	.count-others {
		font-size: 10px;
		color: var(--primary-font-color);
	}
}
</style>
